import { render, staticRenderFns } from "./OtherStatistics.vue?vue&type=template&id=13ada12d&"
import script from "./OtherStatistics.vue?vue&type=script&lang=js&"
export * from "./OtherStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OtherStatistics.vue?vue&type=style&index=0&id=13ada12d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports